import { Post } from '@/service/request/server';
import { envConfig } from '../../../env';

/**
 * 为多个角色增加多个权限
 * @returns {Promise<unknown>}
 */
export function insertPermissionsForRoles(roleList, permissionList) {
    return Post(envConfig.formalServer + "/cotton/insertPermissionsForRoles", {roleList, permissionList})
}

/**
 * 删除某个角色的多个权限
 */
export function deletePermissionsForRole(roleList, permissionList) {
    return Post(envConfig.formalServer + "/cotton/deletePermissionsForRole", {roleList, permissionList})
}

/**
 * 为多个用户插入多个项目组
 */
export function insertProjectGroupsForUsers(userAdminList, projectGroupList) {
    return Post(envConfig.formalServer + "/cotton/insertProjectGroupsForUsers", {userAdminList, projectGroupList})
}

/**
 * 从一个项目组中删除多个用户
 */
export function deleteUsersFromProjectGroup(userAdminList, projectGroupList) {
    return Post(envConfig.formalServer + "/cotton/deleteUsersFromProjectGroup", {userAdminList, projectGroupList})
}

/**
 * 查询所有角色的权限信息
 */
export function queryAllRolePermissionRelation(roleList) {
    return Post(envConfig.formalServer + "/cotton/queryAllRolePermissionRelation", {roleList})
}

/**
 * 查询用户的权限信息
 */
export function queryAllUserPermissionRelation(userAdminList) {
    return Post(envConfig.formalServer + "/cotton/queryAllUserPermissionRelation", userAdminList)
}

/**
 * 查询组内的成员列表
 * @param groupId
 * @returns {Promise | Promise<unknown>}
 */
export function queryGroupMembers(groupId) {
    return Post(envConfig.formalServer + '/cotton/queryGroupMembers', { groupId: groupId });
}